/**
 * Set on Genius deeplink report; cleared on logout.
 * Hides Switch Profile / Switch Product in the header avatar menu.
 */
const GENIUS_HIDE_SWITCH_MENU_KEY = "genius_hide_switch_menu";
const GENIUS_HIDE_SWITCH_MENU_EVENT = "genius-hide-switch-menu";

function notify(): void {
  try {
    window.dispatchEvent(new Event(GENIUS_HIDE_SWITCH_MENU_EVENT));
  } catch {
    // ignore
  }
}

export function markGeniusHideSwitchMenu(): void {
  try {
    localStorage.setItem(GENIUS_HIDE_SWITCH_MENU_KEY, "1");
    notify();
  } catch {
    // ignore
  }
}

export function isGeniusHideSwitchMenuActive(): boolean {
  try {
    return localStorage.getItem(GENIUS_HIDE_SWITCH_MENU_KEY) === "1";
  } catch {
    return false;
  }
}

export function clearGeniusHideSwitchMenu(): void {
  try {
    localStorage.removeItem(GENIUS_HIDE_SWITCH_MENU_KEY);
    notify();
  } catch {
    // ignore
  }
}

export function subscribeGeniusHideSwitchMenu(
  onStoreChange: () => void,
): () => void {
  window.addEventListener(GENIUS_HIDE_SWITCH_MENU_EVENT, onStoreChange);
  return () => {
    window.removeEventListener(GENIUS_HIDE_SWITCH_MENU_EVENT, onStoreChange);
  };
}
